import { useNavigate, useLocation } from "react-router-dom";
import { usePlaySound } from "common/utils";
import parentI18n from "features/parent/i18n";

export const BackBtn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const playSound = usePlaySound();

  const handleBack = () => {
    playSound();

    switch (location.pathname) {
      case "/auth/login":
        navigate("/", { replace: true });
        break;
      case "/auth/email-login":
        navigate("/auth/login", { replace: true });
        break;
      case "/auth/password-reset":
        navigate("/auth/email-login", { replace: true });
        break;
      case "/auth/register":
        navigate("/", { replace: true });
        break;
      case "/auth/email-register":
        navigate("/auth/register", { replace: true });
        break;
      case "/auth/qr-login":
        navigate("/auth/login", { replace: true });
        break;
      default:
        navigate("/", { replace: true });
        break;
    }
  };

  return (
    <button
      className="flex-col-el items-center justify-center w-[80px] h-[64px] bg-gray2-30 rounded-lg text-textcolor-black cursor-pointer border-none hover:bg-gray2-40 transition-all"
      onClick={handleBack}
    >
      <span className="material-symbols-outlined text-[28px]">arrow_back</span>
      <span className="text-[16px]">{parentI18n.t("MSG_BACK_BTN")}</span>
    </button>
  );
};
